import React, { useEffect, useRef, useState } from "react";
import { classes } from "../../../core/data/json/classes";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import {
  activeList,
  classSection,
  classSylabus,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../core/common/commonSelect";
import { Link } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import UserService from "../../network/services/UserService";
import { getUser } from "../../network/auth/Auth";
import { Modal, Toast } from "react-bootstrap";
import Select, { GroupBase } from "react-select";
import moment from "moment";
import { firestore } from "../../../firebase";
import { getFirestore, collection, doc, setDoc, addDoc } from 'firebase/firestore'; // pour la version 9 et ultérieures




const Classes = () => {
  const routes = all_routes;

  const data = classes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const route = all_routes

  const listeChoices = [
    {
      id: "1",
      class: "I",
      section: "A",
      subjectGroup: "I, C English",
      createdDate: "10 May 2024",
      status: "Active",
      key: 1,
    },
    {
      id: "2",
      class: "I",
      section: "B",
      subjectGroup: "III, A Maths",
      createdDate: "11 May 2024",
      status: "Active",
      key: 2,
    },
    {
      id: "3",
      class: "II",
      section: "A",
      subjectGroup: "II, A English",
      createdDate: "12 May 2024",
      status: "Active",
      key: 3,
    },
    {
      id: "4",
      class: "II",
      section: "B",
      subjectGroup: "IV, A Physics",
      createdDate: "13 May 2024",
      status: "Active",
      key: 4,
    },]

  const multiselectwithplaceholder = [
    { value: "fr-1", label: "Apple" },
    { value: "fr-2", label: "Mango" },
    { value: "fr-3", label: "Orange" },
    { value: "fr-4", label: "Guava" },
    { value: "fr-5", label: "Pineapple" },
  ];
  const evaluationTypes = [{ value: 'normal', label: 'Normal' }, { value: 'GPA', label: 'GPA' },
  { value: 'CWA', label: 'CWA' }, { value: 'CCE', label: 'CCE' }];


  const typeUsers = [
    { value: 'user', label: 'Users' },
    { value: 'driver', label: 'Drivers' },
  ];

  interface Option {
    id: any;
    name: any;
  }


  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [isActionSuccessfulEdit, setIsActionSuccessfulEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    code: '',
    evaluation_type: '',
    subject_ids: [],
    max_unit_load: '',
    min_unit_load: '',
    operating_branch_id: '',
    company_id: ''
  });




  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);






  const [multiSubject, setMultiSubject] = useState<OptionType[]>([]);



  const [courses, setCourses] = useState<any[]>([]);
  const [branch, setBranch] = useState<any>();
  const branches = useState<any>([]);







  interface OptionType {
    label: string;
    value: number;
  }

  const [subjects, setSubjects] = useState<OptionType[]>([]);




  const [formData, setFormData] = useState({
    message: ''
  });

  const [choice, setChoice] = useState('Drivers')

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(undefined);
  const [sendUser, setSendUser] = useState<any>(true);
  // Fonction de gestion du changement
  const handleSelectChange = (option: any) => {
    setSelectedOption(option || undefined);
    // Ici, vous pouvez également faire d'autres actions avec l'option sélectionnée
    console.log("Option sélectionnée :", option);
    if (option?.value === "user") {
      setSendUser(true)
    } else {
      setSendUser(false)
    }
  };


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    console.log('Form Data:', formData);
    const request = {
      content: formData.message,
    };

    // Effectuez la requête API d'abord
    UserService.addMessage(request, async (response: any) => {
      if (response?.message) {
        // Si la requête API est un succès, sauvegardez dans Firestore
        const messageRequest = {
          content: request.content,
          read: false,
          created_at: new Date(), // ou utilisez Firestore Timestamp
          user_name: {
            id: getUser()?.id,
            name: getUser()?.name
          }
        };
        const docRef = doc(collection(firestore, 'messages'), 'message');

        try {
          const docRef = await addDoc(collection(firestore, 'messages'), messageRequest);
          console.log('Document written with ID: ', docRef.id);
          setIsLoading(false);
          getAllDrivers(); // Récupérer tous les messages
          handleClose(); // Fermer le modal ou effectuer une autre action si nécessaire
        } catch (error: any) {
          console.error('Error adding document: ', error);
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        console.error('Error from API response:', response);
      }
    });
  };


  const handleSubmitToUsers = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    console.log('Form Data:', formData);
    const request = {
      content: formData.message,
    };

    // Effectuez la requête API d'abord
    UserService.addMessageUsers(request, async (response: any) => {
      if (response?.message) {
        // Si la requête API est un succès, sauvegardez dans Firestore
        const messageRequest = {
          content: request.content,
          read: false,
          created_at: new Date(), // ou utilisez Firestore Timestamp
          user_name: {
            id: getUser()?.id,
            name: getUser()?.name
          }
        };
        const docRef = doc(collection(firestore, 'messages-users'), 'messages-users');

        try {
          const docRef = await addDoc(collection(firestore, 'messages-users'), messageRequest);
          console.log('Document written with ID: ', docRef.id);
          setIsLoading(false);
          getAllUsers(); // Récupérer tous les messages
          handleClose(); // Fermer le modal ou effectuer une autre action si nécessaire
        } catch (error: any) {
          console.error('Error adding document: ', error);
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        console.error('Error from API response:', response);
      }
    });
  };





  const [messages, setMessages] = useState<any>([]);

  const getAllDrivers = () => {

    UserService.getMessages((response: any) => {
      console.log(response?.length > 0)
      setChoice('Drivers')
      if (response?.length > 0) {
        setMessages(response)
      } else {
        setMessages([])
      }
    })
  }

  useEffect(() => {
    getAllDrivers()
  }, [])



  const getAllUsers = () => {

    UserService.getMessagesUsers((response: any) => {
      console.log(response?.length > 0)
      setChoice('Users')
      if (response?.length > 0) {
        setMessages(response)
      } else {
        setMessages([])
      }
    })
  }



  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <Link to="#" className="link-primary">
            {record.id}
          </Link>
        </>
      ),
    },

    {
      title: "Sender name",
      dataIndex: "user_name",
      sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: "Message",
      dataIndex: "content",
      sorter: (a: any, b: any) =>
        a.content.length - b.content.length,
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (record: any) => (
        <div className="d-flex flex-wrap gap-2">

          <span className=" ">
            {moment(record).format("YYYY-MM-DD HH:mm:ss")}
          </span>

        </div>
      ),
      sorter: (a: any, b: any) =>
        a.created_at.length - b.created_at.length,
    },

    {
      title: "Action",
      // dataIndex: "action",
      render: (record: any) => (
        <div className="d-flex align-items-center">
          <div className="dropdown">
            <Link
              to="#"
              className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"

            >
              <i className="ti ti-dots-vertical fs-14" />
            </Link>
            <ul className="dropdown-menu dropdown-menu-right p-3">

              <li>
                <Link className="dropdown-item rounded-1" to='#' >
                  <i className="ti ti-edit-circle me-2" />
                  Edit
                </Link>
              </li>

              <li>
                <Link className="dropdown-item rounded-1" to="#" data-bs-toggle="modal" data-bs-target="#delete-modal">
                  <i className="ti ti-trash-x me-2" />
                  Delete
                </Link>
              </li>
            </ul>
          </div>
        </div>
      ),
    },

  ];
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Message List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={route.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Message </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Message
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />

              <Link to="#" className="btn btn-primary d-flex align-items-center" onClick={handleShow}>
                <i className="ti ti-square-rounded-plus me-2" />
                Add Message
              </Link>



            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Message List</h4>
              <div className="d-flex align-items-center flex-wrap">


                <div className="dropdown mb-3">
                  <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="ti ti-sort-ascending-2 me-2" />
                    {choice}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li onClick={getAllDrivers}>
                      <a className="dropdown-item rounded-1" >
                        Drivers
                      </a>
                    </li>
                    <li onClick={getAllUsers}>
                      <a className="dropdown-item rounded-1" >
                        Users
                      </a>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Guardians List */}
              <Table columns={columns} dataSource={messages} Selection={true} />
              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      ;{/* /Page Wrapper */}
      <>
        {/* Add Classes */}
        <div className="modal fade" id="add_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Class</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Class Name</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        <CommonSelect
                          className="select"
                          options={classSection}
                          defaultValue={classSection[0]}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Students</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Subjects</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-sm"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to="#" className="btn btn-primary" data-bs-dismiss="modal">
                    Add Class
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Classes */}
        {/* Edit Classes */}
        <div className="modal fade" id="edit_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Class</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Class Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Class Name"
                          defaultValue="I"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        <CommonSelect
                          className="select"
                          options={classSection}
                          defaultValue={classSection[0]}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Students</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter no of Students"
                          defaultValue={30}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Subjects</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter no of Subjects"
                        // defaultValue={03}
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-sm2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to="#" className="btn btn-primary" data-bs-dismiss="modal">
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Classes */}
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form >
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-danger" data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
        {/* View Classes */}
        <div className="modal fade" id="view_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title">Class Details</h4>
                  <span className="badge badge-soft-success ms-2">
                    <i className="ti ti-circle-filled me-1 fs-5" />
                    Active
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Class Name</p>
                        <span>III</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Section</p>
                        <span>A</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Subjects</p>
                        <span>05</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Students</p>
                        <span>25</span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /View Classes */}


        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form >
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirmer la verification</h4>
                  <p>
                    Vous souhaitez verifier ce compte
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Fermer
                    </Link>
                    <Link to="#" className="btn btn-danger" data-bs-dismiss="modal"
                    >
                      Oui, Verifier
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}




        <Modal show={showModal} onHide={handleClose} >
          <Modal.Header >
            <Modal.Title>Add Message</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Type users</label>
                      <CommonSelect
                        className="select"
                        options={typeUsers}
                        //defaultValue={typeUsers[0]}
                        onChange={handleSelectChange} // Passer la fonction de rappel ici
                      />

                    </div>
                    <div className="mb-3">
                      <label className="form-label">Message</label>
                      <textarea
                        className="form-control"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span className="btn btn-light me-2" onClick={handleClose}>
                  Cancel
                </span>
                {sendUser ? (
                  <button className="btn btn-primary" onClick={handleSubmitToUsers}>
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm align-middle me-1"
                          role="status"
                          aria-hidden="true"
                        />
                        Loading...
                      </>
                    ) : (
                      "Add Message"
                    )}
                  </button>) : (
                  <button onClick={handleSubmit} className="btn btn-primary">
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm align-middle me-1"
                          role="status"
                          aria-hidden="true"
                        />
                        Loading...
                      </>
                    ) : (
                      "Add Message"
                    )}
                  </button>
                )}
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Modal show={showModal2} onHide={handleClose2} >
          <Modal.Header >
            <Modal.Title>Edit Course</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose2}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={selectedRecord?.name}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Code</label>
                      <input type="text" className="form-control" name="code" value={selectedRecord.code}
                      />

                    </div>
                    <div className="mb-3">
                      <label className="form-label">Minimum Unit Load</label>
                      <input type="number" className="form-control" name="min_unit_load"
                        value={selectedRecord.min_unit_load}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Maximum Unit Load</label>
                      <input type="number" className="form-control" name="max_unit_load"
                        value={selectedRecord.max_unit_load}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">	Evaluation Type</label>
                      <select

                        className="select react-select form-control"
                        name="evaluation_type"
                        value={selectedRecord?.evaluation_type || ''}

                      >
                        <option >Select Evaluation Type</option>
                        {evaluationTypes && evaluationTypes?.map((item: any) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}

                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Subject(s)</label>
                      <Select
                        classNamePrefix="react-select"
                        options={subjects}
                        className="js-example-placeholder-multiple select2 js-states"
                        isMulti={true}
                        name="subject_ids"

                        defaultValue={multiSubject}

                        placeholder="Select"
                      />
                    </div>



                    <div className="mb-3">
                      <label className="form-label">Branch</label>
                      <select
                        className="select react-select form-control"
                        name="operating_branch_id"
                        value={selectedRecord?.operating_branch_id?.[0]?.id || ''}// Assurez-vous que cette valeur correspond à une option

                      >
                        {branches && branches.map((item: any) => (
                          <option value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>

                    </div>


                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose2}
                >
                  Cancel
                </span>
                <Link to="#" className="btn btn-primary"  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Edit Course"}

                </Link>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Toast
          show={showDangerToast}
          onClose={handleDangerToastClose}
          id="dangerToast"
          className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{ minWidth: "200px!important" }}
        >
          <Toast.Header closeButton className="bg-danger text-fixed-white">
            <strong className="me-auto">Message</strong>
            <span
              className="cursor-pointer"
              onClick={handleDangerToastClose}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            />
          </Toast.Header>
          <Toast.Body>
            {/* Add your toast content here */}
            {errorMessage}
          </Toast.Body>
        </Toast>

        <Toast
          show={showSuccessToast}
          onClose={handleSuccessToastClose}
          id="successToast"
          className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >

          <Toast.Body>
            {/* Add your toast content here */}
            {successMessage}
          </Toast.Body>
        </Toast>

      </>
    </div>
  );
};

export default Classes;
